import type { Session } from "@supabase/supabase-js";
import { TinkrApiError, tinkrApiFetch } from "./client";
export interface ProviderShopStatus {
  displayName: string;
  acceptingJobs: boolean;
  operationalStatus: "inactive" | "active" | "suspended" | "deleted";
}
export function getProviderShopStatus(session: Session, signal?: AbortSignal) {
  return tinkrApiFetch<{ ok: true; provider: ProviderShopStatus }>(session, "/v1/provider/shop-status", { signal });
}

/** The side-nav shop chip (`warm-shop-status:provider:<uid>`), shared by the
 * chrome and the console bootstrap prefetch. Pre-onboarding accounts have no
 * provider record (404); accounts without provider access get 401/403. Both
 * mean "no chip", not "error" — the dashboard gates handle their own copy. */
export function providerShopStatusFetcher(session: Session) {
  return async (signal?: AbortSignal): Promise<ProviderShopStatus | null> => {
    try {
      return (await getProviderShopStatus(session, signal)).provider;
    } catch (error) {
      if (error instanceof TinkrApiError && (error.status === 404 || error.status === 403 || error.status === 401)) return null;
      throw error;
    }
  };
}
